import { Controller } from "@hotwired/stimulus"
import { ExecutionSession } from "../services/execution_session.js"

// Connects to data-controller="workflow-execution-session"
//
// This controller is responsible for managing the workflow execution session.
export default class extends Controller {
  static values = {
    stepId: String,
    workflowId: String,
    workflowExecutionId: String,
  }

  static targets = ['executeStepFrame']

  connect() {
    if (this.hasExecuteStepFrameTarget) {
      const mockBaseUrl = "https://example.com"
      const url = new URL(this.executeStepFrameTarget.getAttribute('src'), mockBaseUrl)
      url.searchParams.set('step_execution[workflow_execution_id]', this.workflowExecutionId)
      this.executeStepFrameTarget.setAttribute('src', `${url.pathname}${url.search}`)

      if (this.session().stepExecutionId) {
        const src = `/steps/${this.stepIdValue}/step_executions/${this.session().stepExecutionId}`
        this.executeStepFrameTarget.setAttribute('src', src)
      } else if (this.workflowExecutionId) {
        const src = `/steps/${this.stepIdValue}/step_executions/find_or_create?workflow_execution_id=${this.workflowExecutionId}`
        this.executeStepFrameTarget.setAttribute('src', src)
      }
    }
  }

  // This method sets the workflow execution and step execution session. It is
  // remembered for the current window/tab in the browser.
  //
  // Usage:
  //   <div data-controller="workflow-execution-session"
  //        data-action="click->workflow-execution-session#setStepExecution"
  //        data-workflow-execution-session-step-execution-id="2"></div>
  setStepExecution({ params: { stepExecutionId } }) {
    this.session().store(
      this.workflowIdValue,
      this.stepIdValue,
      this.workflowExecutionIdValue,
      stepExecutionId
    )
  }

  // This method sets the workflow execution session. It is remembered for the
  // current window/tab in the browser.
  //
  // Usage:
  //   <div data-controller="workflow-execution-session"
  //        data-workflow-execution-session-workflow-execution-id-value="<%= step_execution.workflow_execution.id %>"
  //        data-workflow-execution-session-step-id-value="<%= step_execution.step.id %>"
  //        data-action="click->workflow-execution-session#setWorkflowExecution"></div>
  setWorkflowExecution() {
    this.session().workflowExecutionId = this.workflowExecutionIdValue
    // this.latestWorkflowExecutionId = this.workflowExecutionIdValue
  }

  setStepExecutionSubIndex({ target, params: { stepExecutionId } }) {
    const subIndex = target.value

    this.stepExecutionSubIndexes = this.stepExecutionSubIndexes || {}
    this.stepExecutionSubIndexes[stepExecutionId] = subIndex
  }

  goToStepExecutionSubIndex({ target, params: { stepExecutionId, stepId, subStepId } }) {
    this.setStepExecutionSubIndex({ target, params: { stepExecutionId } })
    const subIndex = this.stepExecutionSubIndexes[stepExecutionId]

    const src = `/steps/${stepId}/step_executions/find_or_create?parent_id=${stepExecutionId}&sub_index=${subIndex}&sub_step_id=${subStepId}`

    const frame = document.getElementById('step-execution-manual-runner-frame')
    frame.setAttribute('src', src)
    frame.reload()
  }

  session() {
    return new ExecutionSession({
      stepId: this.stepIdValue,
      workflowExecutionId: this.workflowExecutionIdValue,
      workflowId: this.workflowIdValue
    })
  }

  get workflowExecutionId() {
    return this.workflowExecutionIdValue || this.session().workflowExecutionId
  }
}
